// features/ClientWrapper.tsx (Final Version)
'use client';
import { useEffect, useState } from 'react';
import PasswordModal from './PasswordModal';

export default function ClientWrapper({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  // 2. If the feature is disabled, render the website immediately and stop.
  const [isVerified, setIsVerified] = useState(true);
  const isPasswordProtectionEnabled =
    typeof window !== 'undefined' &&
    window.location.origin === 'https://beta.kireibd.com';

  useEffect(() => {
    console.log('checking password protection', window.location.origin);

    const verified = localStorage.getItem('password_kirei') || '';
    if (verified === 'Tork') {
      setIsVerified(true);
    } else {
      setIsVerified(false);
    }
  }, []);

  if (isPasswordProtectionEnabled && !isVerified) {
    return <PasswordModal setIsVerified={setIsVerified} />;
  } else {
    return <>{children}</>;
  }
}
